import React, {Component} from 'react';
import { connect } from 'react-redux';
import { getFormValues , reduxForm , change} from 'redux-form';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Wait from '@react/react-spectrum/Wait';
import DataSection from '../../comps/DataSection/DataSection';
// import geoPolData from '../config/geoPolData';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';
import {answersToFields} from '../utils/api/processor';
import SaveNExit from './save_n_ext';
import Validation from '../../comps/validation';
import FieldLabel from '@react/react-spectrum/FieldLabel';

//question import
import questions_en_US from '../config/questions/en_US.json';
import questions_zh_CN from '../config/questions/zh_CN.json';
import questions_fr from '../config/questions/fr.json';
import questions_de from '../config/questions/de.json';
import questions_it from '../config/questions/it.json';
import questions_ja from '../config/questions/ja.json';
import questions_ko from '../config/questions/ko.json';
import questions_es from '../config/questions/es.json';
import questions_en_GB from '../config/questions/en_GB.json';
import Rule from '@react/react-spectrum/Rule/js/Rule';



class Questionnaire extends Component{ 

    constructor()
    {
        super();
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {},
            displaySections : []
        }
        this.requiresSecondary = [/*"Primary-11-ynu-1","Primary-11-ynu-2","Primary-11-ynu-3",
    "Primary-11-ynu-4","Primary-11-ynu-5","Primary-11-ynu-6","Primary-11-ynu-7"*/]
        this.secondarySections = [/*"section6","section7","section8","section9","section10","section10_1",
"section11","section11_1","section12","section13"*/]
        this.secondaryFields = [/*"Secondary_9","Secondary_9_answer1","Secondary_9_answer3","Secondary_9_answer5","Secondary_9_answer7",
            "Secondary_9_answer2","Secondary_9_answer4","Secondary_9_answer6","Secondary_9_answer8","Secondary_10",
            "Secondary_10_answer1","Secondary_10_answer3","Secondary_10_answer5","Secondary_10_answer7","Secondary_10_answer2",
            "Secondary_10_answer4","Secondary_10_answer6","Secondary_10_answer8","Secondary_12_ynu","Secondary_13_ynu",
"Secondary_15_ynu","Secondary_17_ynu"*/]
        this.questions = questions_en_GB;
        this.mapGeneratedSection = {
            "Secondary_9_answer1" : "section4_column_0",
            "Secondary_9_answer2" : "section4_column_1",
            "Secondary_9_answer9" : "section4_column_2",
            "Secondary_10_answer1" : "section100_column_0",
            "Secondary_10_answer2" : "section100_column_1",
            "Secondary_10_answer9" : "section100_column_2"
        }
    }

    state = {
        formInitialized : false
    }

    componentDidMount() {
        this.props.onNextBtnVisible(false); 
        this.props.connector.fetchAnswers(this.fetchAnswersComplete,this.props.formStates.accountId,{'context':this.props.formStates.context,'level':this.props.formStates.draftLevel,answersonly:true});
        this.questions = this.getQuestions();
    }

    getQuestions = () =>{
       switch(this.props.locale){
           case 'en_US':
               if(this.props.formStates.showRetailFocusQues)
                {return questions_en_US;}
                else
                {
                    return questions_en_GB;
                }
            case 'zh_CN':
                return questions_zh_CN;
            case 'fr_FR':
                return questions_fr;
            case 'de_DE':
                return questions_de;
            case 'it_IT':
                return questions_it;
            case 'ja_JP':
                return questions_ja;
            case 'ko_KR':
                return questions_ko;
            case 'es_ES':
                return questions_es;
            default:
                return questions_en_GB;
       }
    }

    fetchAnswersComplete = (response) => {
        if(response.answers){
            let initFields = {};
            if (this.props.partnerData) {
                initFields = { ...this.props.formStates,...answersToFields(response.answers)}
            }
            this.props.initialize(initFields);
            this.setState({ formInitialized: true});
        }
        else{
            let initFields = {};
            if (this.props.partnerData) {
                initFields = {...this.props.formStates}
            }
            this.props.initialize(initFields);
            this.setState({ formInitialized: true});
        }
        this.props.onNextBtnVisible(true);
    }

    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        const falseSectionList =  this.reformPage();
        let toDelete = [];
        Object.keys(sectionValidation).map((key)=>{
            falseSectionList.map((ele)=> {
                if(key.startsWith(ele))
                {
                    toDelete.push(key);
                }
                return null;
            })
            return null;
        });
        toDelete.map((key)=>{
            delete sectionValidation[key];
            return null;
        });
        this.setState({sectionValidation:sectionValidation});
    }

    resetSecondary = () => {
        this.secondaryFields.map((key)=>{
            this.props.dispatch(change(this.props.form,key,null));
            this.props.untouch(this.props.form,key)
            return null;
        });
    }

    reformPage = () => {
        const showSecondary = this.requiresSecondary.map((answerKey)=>{
            return this.props.formStates[answerKey]}).includes("Yes");
        let falseSectionList = [];
        Object.keys(this.questions).map((key) => {
            if(this.secondarySections.includes(key) && !showSecondary){
                //reset secondary section
                this.resetSecondary();
                falseSectionList.push(key);
            }
            else{
                if(Boolean(this.questions[key]["showOn"]))
                {
                    if(Boolean(this.props.formStates[this.questions[key]["showOn"]]) && !this.questions[key]["showOnValues"].includes(this.props.formStates[this.questions[key]["showOn"]]))
                    {
                        falseSectionList.push(key);
                    }
                }
            }
        })
        return falseSectionList;
    }
    
    mandatorySwitcher = (key) => {
        if(this.state.formInitialized) {
            let localSectionValidation = this.state.sectionValidation;
            if(key == 'section4') {
                let Secondary_9_answer9NE = (this.props.formStates['Secondary_9_answer9'] !== "" && this.props.formStates['Secondary_9_answer9'] != undefined);
                let Secondary_9_answer9E = (this.props.formStates['Secondary_9_answer9'] === "" || this.props.formStates['Secondary_9_answer9'] === undefined);
                let Secondary_9_answer1NE = (this.props.formStates['Secondary_9_answer1'] !== "" && this.props.formStates['Secondary_9_answer1'] != undefined);
                let Secondary_9_answer2NE = (this.props.formStates['Secondary_9_answer2'] !== "" && this.props.formStates['Secondary_9_answer2'] != undefined);
                let Secondary_9_answer12NE =  ( Secondary_9_answer1NE || Secondary_9_answer2NE );
                let Secondary_9_answer1E = (this.props.formStates['Secondary_9_answer1'] === "" || this.props.formStates['Secondary_9_answer1'] === undefined);
                let Secondary_9_answer2E = (this.props.formStates['Secondary_9_answer2'] === "" || this.props.formStates['Secondary_9_answer2'] === undefined);
                let Secondary_9_answer12E =  (Secondary_9_answer1E || Secondary_9_answer2E);
                if(Secondary_9_answer12NE && Secondary_9_answer9NE) {
                    let filledFields = [];
                    let notFilledFields = [];
                    if(Secondary_9_answer9NE) {
                        filledFields.push('Secondary_9_answer9');
                    } 
                    if(Secondary_9_answer1NE) {
                        filledFields.push('Secondary_9_answer1');
                    } else {notFilledFields.push('Secondary_9_answer1');}
                    if(Secondary_9_answer2NE) {
                        filledFields.push('Secondary_9_answer2');
                    } else {notFilledFields.push('Secondary_9_answer2');}
                    this.updateRequired(key, filledFields, true, localSectionValidation);
                    this.updateRequired(key, notFilledFields, false, localSectionValidation);
                } else {
                    if(Secondary_9_answer12NE && Secondary_9_answer9E) {
                        this.updateRequired(key, ['Secondary_9_answer9'], false, localSectionValidation);
                    } else if(Secondary_9_answer12E) {
                        this.updateRequired(key, ['Secondary_9_answer9'], true, localSectionValidation);
                    }
                    
                    if(Secondary_9_answer9NE && Secondary_9_answer12E) {
                        this.updateRequired(key, ['Secondary_9_answer1','Secondary_9_answer2'], false, localSectionValidation);
                    } else if(Secondary_9_answer9E) {
                        this.updateRequired(key, ['Secondary_9_answer1','Secondary_9_answer2'], true, localSectionValidation);
                    }
                }
            }
            if(key == 'section100') {
                let Secondary_10_answer9NE = (this.props.formStates['Secondary_10_answer9'] !== "" && this.props.formStates['Secondary_10_answer9'] != undefined);
                let Secondary_10_answer9E = (this.props.formStates['Secondary_10_answer9'] === "" || this.props.formStates['Secondary_10_answer9'] === undefined);
                let Secondary_10_answer1NE = (this.props.formStates['Secondary_10_answer1'] !== "" && this.props.formStates['Secondary_10_answer1'] != undefined);
                let Secondary_10_answer2NE = (this.props.formStates['Secondary_10_answer2'] !== "" && this.props.formStates['Secondary_10_answer2'] != undefined);
                let Secondary_10_answer12NE =  ( Secondary_10_answer1NE || Secondary_10_answer2NE );
                let Secondary_10_answer1E = (this.props.formStates['Secondary_10_answer1'] === "" || this.props.formStates['Secondary_10_answer1'] === undefined);
                let Secondary_10_answer2E = (this.props.formStates['Secondary_10_answer2'] === "" || this.props.formStates['Secondary_10_answer2'] === undefined);
                let Secondary_10_answer12E =  (Secondary_10_answer1E || Secondary_10_answer2E);
                if(Secondary_10_answer12NE && Secondary_10_answer9NE) {
                    let filledFields = [];
                    let notFilledFields = [];
                    if(Secondary_10_answer9NE) {
                        filledFields.push('Secondary_10_answer9');
                    } 
                    if(Secondary_10_answer1NE) {
                        filledFields.push('Secondary_10_answer1');
                    } else {notFilledFields.push('Secondary_10_answer1');}
                    if(Secondary_10_answer2NE) {
                        filledFields.push('Secondary_10_answer2');
                    } else {notFilledFields.push('Secondary_10_answer2');}
                    // console.log("Secondary_10_answer12NE && Secondary_10_answer9NE");
                    this.updateRequired(key, filledFields, true, localSectionValidation);
                    this.updateRequired(key, notFilledFields, false, localSectionValidation);
                } else {
                    if(Secondary_10_answer12NE && Secondary_10_answer9E) {
                        // console.log("Secondary_10_answer12NE && Secondary_10_answer9E");
                        this.updateRequired(key, ['Secondary_10_answer9'], false, localSectionValidation);
                    } else if(Secondary_10_answer12E) {
                        // console.log("Else Secondary_10_answer12E");
                        this.updateRequired(key, ['Secondary_10_answer9'], true, localSectionValidation);
                    }
                    
                    if(Secondary_10_answer9NE && Secondary_10_answer12E) {
                        // console.log("Secondary_10_answer9NE && Secondary_10_answer12E");
                        this.updateRequired(key, ['Secondary_10_answer1','Secondary_10_answer2'], false, localSectionValidation);
                    } else if(Secondary_10_answer9E) {
                        // console.log("else Secondary_10_answer9E");
                        this.updateRequired(key, ['Secondary_10_answer1','Secondary_10_answer2'], true, localSectionValidation);
                    }
                }
            }
             
        }      
    }

    updateRequired = (key, arrayFieldToUpdate, valToSet, localSectionValidation) => {
        let updateState = false;
        for(let j=0; j<this.questions[key].fields.length; j++) {
            if(arrayFieldToUpdate.includes(this.questions[key].fields[j].name)) {
                this.questions[key].fields[j].required = valToSet;
                if(valToSet === false) {
                    if(this.mapGeneratedSection[this.questions[key].fields[j].name] in localSectionValidation) {
                        // console.log('this.questions[key].fields[j].name ' + this.questions[key].fields[j].name);
                        // console.log('localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]] ' + localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]]);
                        updateState = true;
                        delete localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]];
                    }
                }
                if(valToSet === true) {
                    if(!(this.mapGeneratedSection[this.questions[key].fields[j].name] in localSectionValidation)) {
                        // console.log('this.questions[key].fields[j].name ' + this.questions[key].fields[j].name);
                        // console.log('localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]] ' + localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]]);
                        updateState = true;
                        if(this.questions[key].fields[j].name == 'Secondary_9_answer3') {
                            if(Validation.isWebURL(this.props.formStates[this.questions[key].fields[j].name])) {
                                localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]] = true;
                            } else {
                                localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]] = false;
                            }
                        } else {
                            if(Validation.isString(this.props.formStates[this.questions[key].fields[j].name]) == 'valid') {
                                localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]] = true;
                            } else {
                                localSectionValidation[this.mapGeneratedSection[this.questions[key].fields[j].name]] = false;
                            }
                        }
                    }
                }
            }
        }
        if(updateState) {
            this.setState({sectionValidation: localSectionValidation});
        }
    }

    /*updateRequired = (key, arrayFieldToUpdate, valToSet) => {
        for(let j=0; j<this.questions[key].fields.length; j++) {
            if(arrayFieldToUpdate.includes(this.questions[key].fields[j].name)) {
                this.questions[key].fields[j].required = valToSet;
            }
        }
    }*/

    render(){
        const RULE = <GridRow>
                        <GridColumn size={[12, 12, 12, 12]}>
                            <Rule className="rule" variant="large" />
                        </GridColumn>
                    </GridRow>;
        if(!this.props.isSaveAndExit) {
            this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
            const formName = 'uplevelRenewal';
            let sections = []
            const showSecondary = this.requiresSecondary.map((answerKey)=>{
                return this.props.formStates[answerKey]}).includes("Yes");
            // console.log(this.props);
            // console.log(this.state.sectionValidation);
            Object.keys(this.questions).map((key) => {
                if(!Boolean(this.secondarySections.includes(key) && !showSecondary)){
                    if(Array.isArray(this.questions[key]) && !(Boolean(this.questions[key]["showOn"])))
                    {
                        sections.push(
                            <GridRow key={"row_"+key}>
                                <GridColumn size={[12,12,12,12]} >
                                    <DataSection formStates={this.props.formStates} form={formName} key={key}
                                    field={this.questions[key]} sectionName={key} updateValidation={this.updateValidation}/>
                                </GridColumn>
                            </GridRow>);
                        if(key==="section5" && showSecondary)
                        {
                            sections.push(RULE);
                        }
                    }
                    else
                    {
                        if(Boolean(this.questions[key]["showOn"]))
                        {
                            //show section only if condition matches
                            if(Boolean(this.props.formStates[this.questions[key]["showOn"]]) && this.questions[key]["showOnValues"].includes(this.props.formStates[this.questions[key]["showOn"]]))
                            {
                                if(Boolean(this.questions[key]["noOfColumns"])) {
                                    let columns = []
                                    if(Boolean(this.questions[key]["isDisplayLabel"])) {
                                        sections.push(
                                            <GridRow key={"row_1"+key}>
                                                <GridColumn size={[12,12,12,12]} >
                                                    <div>
                                                    <FieldLabel label={this.questions[key]["displayLabel"]} />
                                                        
                                                    </div>
                                                </GridColumn>
                                            </GridRow>
                                        );
                                    }
                                    for (let i = 0; i < this.questions[key]["noOfColumns"]; i++) {
                                        const columnSectionField = this.questions[key]["fields"].slice(i * this.questions[key]["fields"].length / this.questions[key]["noOfColumns"], (i + 1) * this.questions[key]["fields"].length / this.questions[key]["noOfColumns"]);
                                        if (columnSectionField[0].name.startsWith("Secondary-12-answer") || columnSectionField[0].name.startsWith("Secondary-13-answer")) {
                                            columnSectionField[0].useLabel = false;
                                        }
                                        columns.push(
                                            <GridColumn size={this.questions[key]["size"] ? this.questions[key]["size"][i] : [12, 12, 12, 12]} key={"column_" + key + "-" + i}>
                                                {this.questions[key]["noOfColumns"] > 1
                                                    && (columnSectionField[0].name.startsWith("Secondary-12-answer") || columnSectionField[0].name.startsWith("Secondary-13-answer"))
                                                    && <div style={{ "height": "1.75em" }}>
                                                        <FieldLabel
                                                            label={columnSectionField[0].label}
                                                            necessity={columnSectionField[0].required && "required"}
                                                        />
                                                    </div>}
                                                <DataSection formStates={this.props.formStates} form={formName} key={key + "_" + i}
                                                    field={columnSectionField}
                                                    sectionName={key + "_column_" + i} updateValidation={this.updateValidation} />
                                            </GridColumn>
                                        )
                                    }
                                    sections.push(
                                        <GridRow key={"row_"+key}>
                                            {columns}
                                        </GridRow>);
                                }
                                if(this.questions[key]["type"] === "none") {
                                    sections.push(
                                        <GridRow key={"row_"+key}>
                                            <GridColumn size={[12,12,12,12]} >
                                                <DataSection formStates={this.props.formStates} form={formName} key={key}
                                                field={this.questions[key]} sectionName={key} updateValidation={this.updateValidation}/>
                                            </GridColumn>
                                        </GridRow>);
                                }
                            }
                        }
                        else
                        {
                            let columns = []
                            for(let i=0;i<this.questions[key]["noOfColumns"];i++)
                            {
                                if(key == 'section4' || key == 'section100') {
                                    this.mandatorySwitcher(key);
                                }
                                columns.push(
                                <GridColumn size={ this.questions[key]["size"] ? this.questions[key]["size"][i] : [12,12,12,12]} key={"column_"+key+"-"+i}>
                                    <DataSection formStates={this.props.formStates} form={formName} key={key+"_"+i}
                                    field={this.questions[key]["fields"].slice(i*this.questions[key]["fields"].length/this.questions[key]["noOfColumns"],(i+1)*this.questions[key]["fields"].length/this.questions[key]["noOfColumns"])} 
                                    sectionName={key+"_column_"+i} updateValidation={this.updateValidation}/>
                                </GridColumn>
                                )
                            }
                            sections.push(
                                <GridRow key={"row_"+key}>
                                    {columns}
                                </GridRow>);
                        }
                        
                    }
                }
            return null;
        });
        
        return <div>
            <Grid>
            {this.state.formInitialized ?
              
                <GridRow>
                    <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]}>
                        <Heading className = "textBold" variant="pageTitle"><Translate value="uplevelRenewal.OnbrdPrimaryQuestionnaireHeader" /></Heading>
                            <p><Translate value="uplevelRenewal.OnbrdPrimaryQuestionnaireSectionHeader" /></p>
                                {sections}
                    </GridColumn>
                </GridRow>
             : 
             <GridRow>
                <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]} style={{"textAlign":"center"}}>
                    <Wait size="L" />
                </GridColumn>
             </GridRow>
            }
            </Grid>
            </div>
        }
        else
        {
            return <SaveNExit />;
        }
    }
}

const Questionnaire1 = reduxForm({
    form:'uplevelRenewal',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(Questionnaire);

function mapStateToProps(state) {
return {
        formStates: getFormValues('uplevelRenewal')(state), // here 'form' is the name you have given your redux form
        locale: state.i18n.locale,
}
}

export default connect(mapStateToProps)(Questionnaire1);